import { Injectable } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { DataService } from '../data.service';



@Injectable({
  providedIn: 'root'
})
export class NotificationResolverService {

  constructor(private dataService: DataService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
      return this.dataService.getDataFromUrl('notifikacije/' +route.params['id']);
}

}
